import { Component, OnInit } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';
import { KeycloakService } from 'keycloak-angular';
import { environment } from "../../../environments/environment";
import moment from 'moment';

@Component({
  selector: 'app-mcommunity',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss'],
})
export class mCommunityComponent implements OnInit {

  userMetadata
  user$
  protected readonly environment = environment;
  discussions = []
  included = []
  private rawHttp: HttpClient;
  protected readonly moment = moment;

  constructor(private http: HttpClient, private data: DataService, public keycloak: KeycloakService, private httpBackend: HttpBackend) { }

  async ngOnInit() {
    this.user$ = await this.keycloak.loadUserProfile();
    this.userMetadata = await this.data.getFromStorage("userMetadata")
    this.rawHttp = new HttpClient(this.httpBackend);
    this.getDiscussions()
  }

  async getDiscussions() {
    await this.rawHttp
      .get(
        '/api/forum-proxy/discussions',
        {
          headers: {
            'Content-Type': 'application/json',
            //"Authorization": "Token 1c67499c-1af8-4531-a9c0-204ad2100f80; userId=" + this.userMetadata.forumid, //; userId=2
            "kieg": this.userMetadata.forumid ? "; userId=" + this.userMetadata.forumid : ""
          }
        }
      )
      .subscribe({
        next: (response: any) => {
          this.discussions = response.data.reverse()
          this.included = response.included
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }

}
